// 密码为8-20位，至少包含大小写字母/数字/符号 3种组合（不含中文）
export const pwd = /^(?=[^\u4e00-\u9fa5]+$)(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,20}$/